import BetslipNotifications from './_betslip-notifications.js'

export default {
  name: 'BetErrors',
  values: {
    betslipNotifications: {
      configSet: BetslipNotifications,
      configValues: {
        container: {
          style: {
            padding: '0 0 8px 0',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
